$(document).foundation();

var kioskMode = $('body').hasClass('kiosk-mode')
var isMenuOpened = false
var jumpNumber = 0
var maxJumpNumber = 38
var $body = $('body')
var $menu = $('.menu')

// toggle grid
$('nav a.grid-toggle').on('click', function(e) {
  $body.toggleClass('grid-overlay--is-showing')
  e.preventDefault()
})

// toggle menu
function closeMenu() {
  $body.removeClass('menu--is-showing')
  setTimeout(function(e) {
    $body.removeClass('menu--will-show')
    isMenuOpened = false
  }, 250)
}

function openMenu() {
  $body.addClass('menu--will-show')
  
  // Set focus
  $menu.find('a:first').get(0).focus()
  trapFocus($menu.get(0))

  setTimeout(function(e) {
    $body.addClass('menu--is-showing')
    isMenuOpened = true
  }, 50)
}

$('nav a.menu-toggle').on('click', function(e) {
  if (isMenuOpened) {
    closeMenu()
  } else {
    openMenu()
  }
  e.preventDefault()
})

$menu.on('keydown', function(e) {
  if (e.key === 'Escape') {
    closeMenu()
    e.preventDefault()
  }
});

// jump to sections
gsap.utils.toArray('.menu .set a').forEach(function(a) {
  a.addEventListener("click", function(e) {
    e.preventDefault()
    var offsetY = 0
    var target = e.target.getAttribute('href')
    switch(target) {
      case '#prelude':
        target = '#intro'
        offsetY -= $(window).height() * 1.5
        jumpNumber = 1
      break;
      case '#thesis':
        target = '#intro'
        offsetY -= $(window).height() * 2.5
        jumpNumber = 2
      break;
      case '#the-grid-system':
        offsetY -= $(window).height()
        jumpNumber = 3
      break;
      case '#what-is-the-grid':
        offsetY -= $(window).height() * 1.92
        jumpNumber = 4
      break;
      case '#commentary-top':
        offsetY -= $(window).height()
        jumpNumber = 5
      break;
      case '#before-the-grid':
        offsetY -= $(window).height()
        jumpNumber = 6
      break;
      case '#swiss-style':
        //offsetY -= $(window).height() / 2.5
        //jumpNumber = 11
        target = '#what-is-swiss-style'
        offsetY -= $(window).height() / 3
        jumpNumber = 12
      break;
      case '#what-is-swiss-style':
        offsetY -= $(window).height() / 3
        jumpNumber = 12
      break;
      case '#why-switzerland':
        offsetY -= $(window).height() * 0.25
        jumpNumber = 16
      break;
      case '#typography':
        offsetY -= $(window).height()
        jumpNumber = 20
      break;
      case '#designers':
        offsetY -= $(window).height() / 1.5
        jumpNumber = 23
      break;
      case '#commentary':
        offsetY -= 100
        jumpNumber = 29
      break;
      case '#posters':
        offsetY -= $(window).height() * 0.9
        jumpNumber = 31
      break;
      case '#altered-grid':
        offsetY -= $(window).height() * 1.5
        jumpNumber = 34
      break;
      case '#commentary-kelly-walters':
        offsetY -= $(window).height()
        jumpNumber = 35
      break;
      case '#commentary-shani-sandy':
        offsetY -= $(window).height()
        jumpNumber = 36
      break;
      case '#credits':
        offsetY = 0
        jumpNumber = 38
      break;
    }
    gsap.to(window, {duration: 2, scrollTo: { y: target, offsetY: offsetY } })
    closeMenu()
  })
})

// highlight menu
ScrollTrigger.defaults({
  onEnter: self => {
    if (typeof self.vars.trigger == 'string' || self.vars.trigger instanceof String) {
      var trigger = self.vars.trigger.split(' ')
      var currentSection = trigger[0]
      if (currentSection == '#intro') {
        currentSection = '#thesis'
      }
      if (currentSection == '#end') {
        currentSection = '#credits'
      }
      //console.log(currentSection)
      var $a = $('.menu a[href="' + currentSection + '"]')
      if ($a.length > 0) {
        $('.menu a').removeClass('active')
        $a.addClass('active')
      }
    }
  },
  onEnterBack: self => {
    if (typeof self.vars.trigger == 'string' || self.vars.trigger instanceof String) {
      var trigger = self.vars.trigger.split(' ')
      var currentSection = trigger[0]
      if (currentSection == '#intro') {
        currentSection = '#thesis'
      }
      if (currentSection == '#end') {
        currentSection = '#credits'
      }
      //console.log(currentSection)
      var $a = $('.menu a[href="' + currentSection + '"]')
      if ($a.length > 0) {
        $('.menu a').removeClass('active')
        $a.addClass('active')
      }
    }
  }
});

// Intro
gsap.timeline({
  scrollTrigger: {
    trigger: '#intro .content-blank',
    start: 'top top',
    end: 'bottom bottom',
    scrub: true,
    pin: '#intro .content',
    pinSpacing: false
  }
})
.to('#intro .poster', { duration: 2, yPercent: -150 }, 0)
.to('#intro .house', { duration: 2, yPercent: 150 }, 0)
.to('#intro .the-swiss-grid', { duration: 2, scale: 0 }, 0)
.from('#intro .about p', { opacity: 0 })
.to('#intro .about p', { opacity: 0 }, '+=2')
.to('.arrow', { opacity: 0, y: 50 })
.from('#intro .thesis p', { opacity: 0 })
.to('#intro .thesis p', { opacity: 0 }, '+=2')

// The Grid System
// animates in text the grid system
gsap.timeline({
  scrollTrigger: {
    trigger: '#the-grid-system',
    start: 'top top',
    scrub: true,
    pin: true,
    pinSpacing: false,
    onToggle: function(st) {
      if (st.isActive) {
        $('body').addClass('the-grid-system--is-active')
      } else {
        $('body').removeClass('the-grid-system--is-active')
      }
    }
  }
})
.from('#the-grid-system .the', { xPercent: -200 }, 0)
.from('#the-grid-system .grid', { xPercent: 200 }, 0)
.from('#the-grid-system .system', { xPercent: -200 }, 0)
.to('#the-grid-system .dot', { duration: 0.1, opacity: 1,
  onStart: function() {
    console.log('as')
    $('body').addClass('nav--is-black')
  },
  onReverseComplete: function() {
    $('body').removeClass('nav--is-black')
  }
 })
.to('#the-grid-system .dot', { scale: 0 })

// What is the Grid
// pins content left based on content right
gsap.timeline({
  scrollTrigger: {
    trigger: '#what-is-the-grid .content-right',
    start: 'top top',
    end: 'bottom top',
    scrub: true,
    pin: '#what-is-the-grid .content-left',
    pinSpacing: false,
    onLeave: self => {
      ScrollTrigger.refresh(true)
    }
  }
})
.from('#what-is-the-grid h2', { duration: 0.25, xPercent: 100, fontSize: '170px', opacity: 0 }, 0)
.from('#what-is-the-grid .images', { duration: 0.25, scale: 1.5, opacity: 0 }, 0)
.to('#what-is-the-grid h2', { scale: 1 })

// moves bottom image based on content right
gsap.timeline({
  scrollTrigger: {
    trigger: '#what-is-the-grid .content-right',
    start: '80% bottom',
    end: 'bottom 50%',
    scrub: true,
    pinSpacing: false,
  }
})
.to('#what-is-the-grid h2', { opacity: 0 })
.to('#what-is-the-grid .top-image', { opacity: 0 })
.to('#what-is-the-grid .bottom-image', { opacity: 0, x: innerWidth * 0.5 })

// Audrey Bennett Commentary
gsap.timeline({
  scrollTrigger: {
    trigger: '#commentary-top .content-blank',
    start: 'top top',
    end: 'bottom bottom',
    pin: '#commentary-top .content',
    scrub: true,
    pinSpacing: false
  }
})
.from('#commentary-top .content-left', { duration: 1, opacity: 0, y: 150 })
.from('#commentary-top .content-right', { duration: 1, opacity: 0, y: 150 })
.to('#commentary-top .grid-x', { opacity: 0 }, '+=3')

// Before the Grid
// pins content left based on content right
var beforeTheGridTimeline = gsap.timeline({
  scrollTrigger: {
    trigger: '#before-the-grid',
    start: 'top top',
    end: 'bottom bottom',
    scrub: true,
    pin: '#before-the-grid .content-left',
    pinSpacing: false,
    markers: false
  }
})
// skew turnfest in basel image
gsap.timeline({
  scrollTrigger: {
    trigger: '#turnfest-in-basel .image',
    start: 'top 150%',
    end: 'bottom 75%',
    scrub: true,
    pinSpacing: false,
  }
})
.to('#turnfest-in-basel .image-caption', { duration: 2, skewY: 15 })
.to('#turnfest-in-basel .image-caption', { duration: 2, skewY: 0 })
.to('#before-the-grid .text-turnfest-in-basel', { duration: 2, opacity: 1, zIndex: 2 }, '+=2')
// pin turnfest in basel image
gsap.timeline({
  scrollTrigger: {
    trigger: '#turnfest-in-basel',
    start: 'top top',
    end: 'bottom bottom',
    scrub: true,
    pin: '#turnfest-in-basel .image-caption',
    pinSpacing: false
  }
})
.to('#turnfest-in-basel .image-caption .image', { backgroundSize: '300%', backgroundPosition: '35% 10%' }, '+=0.5')
.to('#turnfest-in-basel .image-caption .image', { backgroundSize: '100%', backgroundPosition: '0% 0%' }, '+=0.5')
.to('#before-the-grid .text-turnfest-in-basel', { opacity: 0 })
.to('#turnfest-in-basel .image-caption', { yPercent: -100, skewY: 15, opacity: 1 })
// skew out turnfest in basel image
gsap.timeline({
  scrollTrigger: {
    trigger: '#turnfest-in-basel .image',
    start: 'top top',
    end: 'bottom top',
    scrub: true,
    pinSpacing: false,
  }
})

// skew pkz image
gsap.timeline({
  scrollTrigger: {
    trigger: '#pkz .image',
    start: 'top 150%',
    end: 'bottom 75%',
    scrub: true,
    pinSpacing: false,
  }
})
.to('#pkz .image-caption', { duration: 1, skewY: 15 })
.to('#pkz .image-caption  ', { duration: 2, skewY: 0 })
.to('#before-the-grid .text-pkz', { duration: 2, opacity: 1, zIndex: 3 }, '+2')
// pin pkz image
gsap.timeline({
  scrollTrigger: {
    trigger: '#pkz',
    start: 'top top',
    end: 'bottom bottom',
    scrub: true,
    pin: '#pkz .image-caption',
    pinSpacing: false,
  }
})
.to('#pkz .image-caption .image', { backgroundSize: '280%', backgroundPosition: '58% 5%' }, '+=0.5')
.to('#pkz .image-caption .image', { backgroundSize: '100%', backgroundPosition: '0% 0%' }, '+=0.5')
.to('#before-the-grid .text-pkz', { opacity: 0 })
.to('#pkz .image-caption', { yPercent: -100, skewY: 15 })

// skew pkz 1924 image
gsap.timeline({
  scrollTrigger: {
    trigger: '#pkz-1924 .image',
    start: 'top 150%',
    end: 'bottom 75%',
    scrub: true,
    pinSpacing: false,
  }
})
.to('#pkz-1924 .image-caption', { duration: 1, skewY: 15 })
.to('#pkz-1924 .image-caption  ', { duration: 2, skewY: 0 })
.to('#before-the-grid .text-pkz-1924', { duration: 2, opacity: 1, zIndex: 4 }, '+2')
// pin pkz-1924 image
gsap.timeline({
  scrollTrigger: {
    trigger: '#pkz-1924',
    start: 'top top',
    end: 'bottom bottom',
    scrub: true,
    pin: '#pkz-1924 .image-caption',
    pinSpacing: false,
  }
})
.to('#pkz-1924 .image-caption .image', { backgroundSize: '280%', backgroundPosition: '58% 5%' }, '+=0.5')
.to('#pkz-1924 .image-caption .image', { backgroundSize: '100%', backgroundPosition: '0% 0%' }, '+=0.5')
.to('#before-the-grid .text-pkz-1924', { opacity: 0 })
.to('#pkz-1924 .image-caption', { yPercent: -100, skewY: 15 })

// Swiss Style
// move and zoom
gsap.timeline({
  scrollTrigger: {
    trigger: '#swiss-style .content',
    start: 'top top',
    end: 'bottom 50%',
    scrub: true,
    pin: '#swiss-style .parts',
    pinSpacing: false,
  }
})
.from('#swiss-style .top', { duration: 1, yPercent: -100, ease: 'power2.out',
  onStart: function() {
    $('body').removeClass('nav--is-black')
  },
  onReverseComplete: function() {
    $('body').addClass('nav--is-black')
  }
 }, 0)
.from('#swiss-style .bottom', { duration: 1, yPercent: 100, ease: 'power2.out' }, 0)
.to('#swiss-style .parts', { duration: 4, scale: 50, opacity: 0, transformOrigin: '40% 50%', ease: 'power2.in',
  onStart: function() {
    $('body').addClass('nav--is-black')
  },
  onReverseComplete: function() {
    $('body').removeClass('nav--is-black')
  }
}, '+=1')

// What is Swiss Style
// move and fade
gsap.timeline({
  scrollTrigger: {
    trigger: '#what-is-swiss-style .content-blank',
    start: 'top top',
    end: 'bottom bottom',
    scrub: true,
    pin: '#what-is-swiss-style .content'
  }
})
.from('#what-is-swiss-style p', { opacity: 0, y: 50 }, 0)
.from('#what-is-swiss-style h2', { x: innerWidth * 1.1 }, 0)
.to('#what-is-swiss-style h2', { x: innerWidth * -1.1 }, '+=1')
.to('#what-is-swiss-style p', { opacity: 0, y: -50 })


// International Typographic Style
// blinking effect
gsap.timeline({
  scrollTrigger: {
    trigger: '#international-typographic-style .content-blank',
    start: 'top top',
    end: 'bottom top',
    scrub: true,
    pin: '#international-typographic-style .content',
    pinSpacing: false
  }
})
.to('#international-typographic-style .text-1', { className: 'text text--is-showing' }, 0)
.to('#international-typographic-style .blink.top', { yPercent: -100 }, '+0.5')
.to('#international-typographic-style .blink.bottom', { yPercent: 100 }, '+0.5')
.to('#international-typographic-style .blink.top', { yPercent: 0 }, '+1')
.to('#international-typographic-style .blink.bottom', { yPercent: 0 }, '+1')
.to('#international-typographic-style .text', { className: 'text' }, '+1.5')
.to('#international-typographic-style .text-2', { className: 'text text--is-showing' }, '+1.5')
.to('#international-typographic-style .blink.top', { yPercent: -100 }, '+1.5')
.to('#international-typographic-style .blink.bottom', { yPercent: 100 }, '+1.5')
.to('#international-typographic-style .blink.top', { yPercent: 0 }, '+2')
.to('#international-typographic-style .blink.bottom', { yPercent: 0 }, '+2')
.to('#international-typographic-style .text', { className: 'text' }, '+2.5')
.to('#international-typographic-style .text-3', { className: 'text text--is-showing' }, '+2.5')
.to('#international-typographic-style .blink.top', { yPercent: -100 }, '+2.5')
.to('#international-typographic-style .blink.bottom', { yPercent: 100 }, '+2.5')

// Why Switzerland
// pin right
gsap.timeline({
  scrollTrigger: {
    trigger: '#why-switzerland .content-left',
    start: 'top top',
    end: 'bottom top',
    scrub: true,
    pin: '#why-switzerland .content-right',
    pinSpacing: false
  }
})
// toggle between images as left is scrolled
$('#why-switzerland .text').each(function() {
  var $text = $(this)
  var index = $text.index() - 1
  var $image = $('#why-switzerland .image').eq(index)
  var tl = gsap.timeline({
    scrollTrigger: {
      trigger: $text,
      start: 'bottom bottom',
      end: '60% 60%',
      scrub: true,
      pinSpacing: false,
      markers: false
    }
  })
  .to('#why-switzerland .image', { duration: 1, opacity: 0 } )
  .to($image, { duration: 4, opacity: 1 } )
})

// Typography
//
gsap.timeline({
  scrollTrigger: {
    trigger: '#typography .content-blank',
    start: 'top top',
    end: 'bottom top',
    scrub: true,
    pin: '#typography .content',
  }
})
.from('#typography .content-left', { xPercent: -175 }, 0)
.from('#typography .content-right', { xPercent: 175 }, 0)
.to('#typography .text', {  opacity: 0 }, '+1')
.to('#typography h3', {  opacity: 0.25 }, '+1')
.to('#typography h3.choice-2', { opacity: 1 }, '+2')
.to('#typography .text-2', {  opacity: 1 }, '+2')
.to('#typography .text', {  opacity: 0 }, '+3')
.to('#typography h3', {  opacity: 0.25 }, '+3')
.to('#typography h3.choice-3', { opacity: 1 }, '+4')
.to('#typography .text-3', {  opacity: 1 }, '+4')
.to('#typography .content-left', { opacity: 0, yPercent: -50 }, '+5')
.to('#typography .content-right', { opacity: 0, yPercent: -50 }, '+5')

// Designers
// move and fade
gsap.timeline({
  scrollTrigger: {
    trigger: '#designers .content-blank',
    start: 'top top',
    end: 'bottom bottom',
    scrub: true,
    pin: '#designers .content',
  }
})
.from('#designers .intro h2', { x: innerWidth * 1, fontSize: 170 }, 0)
.from('#designers .intro p', { opacity: 0, y: 50 }, 1)
.to('#designers .intro p', { opacity: 0, xPercent: -75 }, 2)
.from('#designers .more p', { opacity: 0, y: 300 }, 2.5)
.to('#designers .intro h2', { opacity: 0 }, 4)
.to('#designers .more p', { opacity: 0 }, 4)



.from('#designers .map .basel', { yPercent: -150 }, 4)
.from('#designers .map .zurich', { yPercent: 150 }, 4)
.to('#designers .map h2', { opacity: 0 }, 5)
.from('#designers .map .map-outline', { opacity: 0 }, 6)
.to('#designers .map .map-outline', { opacity: 0 }, 7)
.to('#designers .map .map-image', { opacity: 0.10 }, 8)
.from('#designers .map .rules', { opacity: 0 }, 9)
.from('#designers .map .basel .rules span', { opacity: 0, top: 50, stagger: 0.1 }, 10)
.from('#designers .map .zurich .rules span', { opacity: 0, top: 50, stagger: 0.1 }, 10)
.to('#designers .map .rules', { opacity: 0, }, 12)
.from('#designers .map .people', { opacity: 0 }, 13)
.to('#designers .map .people', { opacity: 1, className: 'people people--is-showing' }, 14)
.to('#designers .map .people', { opacity: 1 }, 15)

// Commentary
// move and fade
gsap.timeline({
  scrollTrigger: {
    trigger: '#commentary .content-blank',
    start: 'top top',
    end: 'bottom bottom',
    scrub: true,
    pin: '#commentary .content',
    pinSpacing: false
  }
})
.to('#commentary .intro', { opacity: 0, xPercent: -50 }, 1)
.from('#commentary .people', { opacity: 0, xPercent: 30 }, 1.5)
.to('#commentary .people', { opacity: 1 }, 3)

// Posters
// pin right
gsap.timeline({
  scrollTrigger: {
    trigger: '#posters .content-left',
    start: 'top top',
    end: 'bottom bottom',
    scrub: true,
    pin: '#posters .content-right'
  }
})
.from('#posters h2', { opacity: 0 }, 0)
.from('#posters .deck', { opacity: 0, x: -50 }, 0)


$('#posters .thumbnails .cell').each(function() {
  var index = $(this).index()
  var randomTop = Math.floor(Math.random() * 100) + 25
  var randomLeft = Math.floor(Math.random() * 100) + 25
  if (index % 2 == 0) {
    randomTop = Math.floor(Math.random() * 100) - 25
    randomLeft = 0 - (Math.floor(Math.random() * 100) + 25)
  }

  var $img = $(this).find('img')
  gsap.timeline({
    scrollTrigger: {
      trigger: $img,
      start: 'top 75%',
      end: 'top 25%',
      scrub: true,
      markers: false
    }
  })
  .from($img, { delay: 0.1, y: randomTop, x: randomLeft }, 0)
})

$('#posters .thumbnails .cell').on('click', function() {
  var index = $(this).index()
  $('#posters .text').removeClass('text--is-showing')
  $('#posters .text.poster-info').eq(index).addClass('text--is-showing')
})

// Altered Grid
// pin right
gsap.timeline({
  scrollTrigger: {
    trigger: '#altered-grid',
    start: 'top top',
    end: 'bottom bottom',
    scrub: true,
    pin: '#altered-grid .grid-container',
    pinSpacing: false,
  }
})
.from('#altered-grid .content-left', { xPercent: -50, opacity: 0 }, 0)
.from('#altered-grid h2', { opacity: 0 })
.from('#altered-grid .grid-types', { opacity: 0 })
.from('#altered-grid .explore', { opacity: 0, xPercent: 100 })
.to('#altered-grid .explore', { opacity: 1 }, '+=1')

$('#altered-grid .grid-type .cell-image').on('click', function() {
  var index = $(this).index()
  $('#altered-grid .grid-type:not(.hide) .cell-image').removeClass('active').eq(index).addClass('active')
  $('#altered-grid .bigs:not(.hide) img').addClass('hide').eq(index).removeClass('hide')
})

$('#altered-grid .explore .cell').on('click', function() {
  var index = $(this).index()
  $('#altered-grid .posters .cell').removeClass('active').eq(index).addClass('active')
  $('#altered-grid .grid-type').addClass('hide').eq(index).removeClass('hide')
  $('#altered-grid .bigs').addClass('hide').eq(index).removeClass('hide')
  $('#altered-grid .grid-type:not(.hide) .cell-image').eq(0).trigger('click')
})
$('#altered-grid .explore .cell').eq(0).trigger('click')
$('#altered-grid .grid-type:not(.hide) .cell-image').eq(0).trigger('click')


// commentary-kelly-walters
gsap.timeline({
  scrollTrigger: {
    trigger: '#commentary-kelly-walters .content-blank',
    start: 'top top',
    end: 'bottom bottom',
    pin: '#commentary-kelly-walters .content',
    scrub: true,
    pinSpacing: false
  }
})
.from('#commentary-kelly-walters .content-left', { duration: 1, opacity: 0, y: 150 })
.from('#commentary-kelly-walters .content-right', { duration: 1, opacity: 0, y: 150 })
.to('#commentary-kelly-walters .grid-x', { opacity: 0 }, '+=3')

// commentary-shani-sandy
gsap.timeline({
  scrollTrigger: {
    trigger: '#commentary-shani-sandy .content-blank',
    start: 'top top',
    end: 'bottom bottom',
    pin: '#commentary-shani-sandy .content',
    scrub: true,
    pinSpacing: false
  }
})
.from('#commentary-shani-sandy .content-left', { duration: 1, opacity: 0, y: 150 })
.from('#commentary-shani-sandy .content-right', { duration: 1, opacity: 0, y: 150 })
.to('#commentary-shani-sandy .grid-x', { opacity: 0 }, '+=3')

if (kioskMode == false) {
  // Student Assignments
  gsap.timeline({
    scrollTrigger: {
      trigger: '#student-assignments .content-blank',
      start: 'top top',
      end: 'bottom bottom',
      scrub: true,
      pin: '#student-assignments .content',
    }
  })
  .from('#student-assignments .view', { x: 300 }, 1)
  .to('#student-assignments .grid-container', { x: -300 }, 1)
  .to('#student-assignments', { opacity: 0 }, 3)
}

// End
// fades in then fades out the text
gsap.timeline({
  scrollTrigger: {
    trigger: '#end .content-blank',
    start: 'top top',
    end: 'bottom 50%',
    scrub: true,
    pin: '#end .content',
    pinSpacing: false,
  }
})
.from('#end h3', { opacity: 0 })
.to('#end h3', { opacity: 1 }, '+1')
.to('#end h3', { opacity: 1 }, '+1.5')

// load images
$('body img:not(.ignore-load)').imagesLoaded().done( function( instance ) {
  ScrollTrigger.refresh(true)
  $('body').addClass('body-images--done-loading')
})

// ramon tejada carousel
var $carouselRamonTejada = $('.carousel-ramon-tejada').flickity({
  cellSelector: '.carousel-cell',
  setGallerySize: true,
  cellAlign: 'left',
  lazyLoad: 5,
  prevNextButtons: false,
  pageDots: false,
  wrapAround: true,
  on: {
    select: function() {
      if ($carouselRamonTejada) {
        var currentIndex = $carouselRamonTejada.data('flickity').selectedIndex
        $('#commentary .counter .current').html(currentIndex + 1)
      }
    }
  }
})
$('#commentary .arrows .next').on('click', function() {
  $carouselRamonTejada.flickity('next',)
})

$('#commentary .arrows .previous').on('click', function() {
  $carouselRamonTejada.flickity('previous',)
})


// student admissions
var $carouselstudent = $('.single-student_assignments .carousel').flickity({
  cellSelector: '.carousel-cell',
  setGallerySize: true,
  cellAlign: 'left',
  prevNextButtons: false,
  pageDots: false,
  imagesLoaded: true,
  wrapAround: false
})

$('.single-student_assignments .arrows .next').on('click', function() {
  $carouselstudent.flickity('next',)
})

$('.single-student_assignments .arrows .previous').on('click', function() {
  $carouselstudent.flickity('previous',)
})

$('.mobile-menu-toggle').on('click', function () {
  $('body').toggleClass('mobile-menu--is-open')
})

// kiosk
if (kioskMode) {
  // prevent scrolls
  $(window).on('touchstart', function() {
    e.preventDefault();
  });
  $(window).on('touchend', function() {
      e.preventDefault();
  })
  $(window).on('touchmove', function(e) {
    e.preventDefault();
  })

  var kioskRefreshTimer = window.setTimeout(function() {
    $('html, body').animate({ scrollTop: 0 }, 500, function() {
      window.location.reload();
    })
  }, 60000)

  // click timer
  $(document).on('click', function() {
    window.clearTimeout(kioskRefreshTimer);
    kioskRefreshTimer = window.setTimeout(function() {
      $('html, body').animate({ scrollTop: 0 }, 500, function() {
        window.location.reload();
      })
    }, 60000)
  })

  // designers person clicks
  $('#designers .person').on('click', function() {
    var $person = $(this)
    var $city = $person.parent().parent().parent()
    if ($person.hasClass('bio--is-showing')) {
      $person.removeClass('bio--is-showing')
      $('#designers .map .basel').removeClass('basel--is-active')
      $('#designers .map .zurich').removeClass('zurich--is-active')
    } else {
      $('#designers .person').removeClass('bio--is-showing')
      $person.addClass('bio--is-showing')
      if ($city.hasClass('basel')) {
        $('#designers .map .basel').addClass('basel--is-active')
        $('#designers .map .zurich').removeClass('zurich--is-active')
      } else {
        $('#designers .map .basel').removeClass('basel--is-active')
        $('#designers .map .zurich').addClass('zurich--is-active')
      }
    }
  })
}

// jump arrows
var jumpDown = true
$('.jump-arrows')
  .on('click', '.arr.up', function() {
    if (jumpNumber <= maxJumpNumber && jumpNumber > 0) {
      jumpNumber--
    }
    jumpDown = false
    doJumpArrowScroll()  
  })
  .on('click', '.arr.down', function() {
    if (jumpNumber > -1 && jumpNumber < maxJumpNumber) {
      jumpNumber++
    }
    jumpDown = true
    doJumpArrowScroll()
  })

function doJumpArrowScroll() {
  var target
  var offsetY = 0
  //console.log(jumpNumber)
  switch (jumpNumber) {
    case 0:
      target = '#intro'
    break;
    case 1:
      target = '#intro'
      offsetY -= $(window).height() * 1.5
    break;
    case 2:
      target = '#intro'
      offsetY -= $(window).height() * 2.5
    break;
    case 3:
      target = '#the-grid-system'
      if (jumpDown) {
        offsetY -= $(window).height()
      } else {
        offsetY = $(window).height()
      }
    break;
    case 4:
      target = '#what-is-the-grid'
      offsetY -= $(window).height() * 1.92
    break;
    case 5:
      target = '#commentary-top'
      offsetY -= $(window).height()
    break;
    case 6:
      target = '#before-the-grid'
      offsetY -= $(window).height()
    break;
    case 7:
      target = '#before-the-grid'
      offsetY -= $(window).height() * 3
    break;
    case 8:
      target = '#before-the-grid'
      offsetY -= $(window).height() * 6
    break;
    case 9:
      target = '#before-the-grid'
      offsetY -= $(window).height() * 8
    break;
    case 10:
      target = '#before-the-grid'
      offsetY -= $(window).height() * 11
    break;
    case 11:
      target = '#before-the-grid'
      offsetY -= $(window).height() * 13
    break;
    case 12:
      target = '#what-is-swiss-style'
      offsetY -= $(window).height() / 3
    break;
    case 13:
      target = '#international-typographic-style'
      offsetY -= $(window).height()
    break;
    case 14:
      target = '#international-typographic-style'
      offsetY -= $(window).height() * 2
    break;
    case 15:
      target = '#international-typographic-style'
      offsetY -= $(window).height() * 3
    break;
    case 16:
      target = '#why-switzerland'
      offsetY -= $(window).height() * 0.25
    break;
    case 17:
      target = '#why-switzerland'
      offsetY -= $(window).height() * 1.2
    break;
    case 18:
      target = '#why-switzerland'
      offsetY -= $(window).height() * 2.02
    break;
    case 19:
      target = '#why-switzerland'
      offsetY -= $(window).height() * 3.0
    break;
    case 20:
      target = '#typography'
      offsetY -= $(window).height()
    break;
    case 21:
      target = '#typography'
      offsetY -= $(window).height() * 3
    break;
    case 22:
      target = '#typography'
      offsetY -= $(window).height() * 5
    break;
    case 23:
      target = '#designers'
      offsetY -= $(window).height() / 1.5
    break;
    case 24:
      target = '#designers'
      offsetY -= $(window).height() * 1.5
    break;
    case 25:
      target = '#designers'
      offsetY -= $(window).height() * 2.25
    break;
    case 26:
      target = '#designers'
      offsetY -= $(window).height() * 3.0
    break;
    case 27:
      target = '#designers'
      offsetY -= $(window).height() * 5.0
    break;
    case 28:
      target = '#designers'
      offsetY -= $(window).height() * 7.0
    break;
    case 29:
      target = '#commentary'
      offsetY -= 100
    break;
    case 30:
      target = '#commentary'
      offsetY -= $(window).height()
    break;
    case 31:
      target = '#posters'
      offsetY -= $(window).height() * 0.9
    break;
    case 32:
      target = '#posters'
      offsetY -= $(window).height() * 1.7
    break;
    case 33:
      target = '#posters'
      offsetY -= $(window).height() * 2.5
    break;
    case 34:
      target = '#altered-grid'
      offsetY -= $(window).height() * 1.5
    break;
    case 35:
      target = '#commentary-kelly-walters'
      offsetY -= $(window).height()
    break;
    case 36:
      target = '#commentary-shani-sandy'
      offsetY -= $(window).height()
    break;
    case 37:
      target = '#end'
      offsetY -= $(window).height() * 0.25
    break;
    case 38:
      target = '#credits'
      offsetY -= $(window).height()
    break;
  }
  //console.log(jumpNumber)
  gsap.to(window, {duration: 1, scrollTo: { y: target, offsetY: offsetY } })
}

// @see https://hidde.blog/using-javascript-to-trap-focus-in-an-element/
function trapFocus(element) {
  var focusableEls = element.querySelectorAll('button, a:not([tabindex="-1"], [tabindex]:not([tabindex="-1"])');
  var firstFocusableEl = focusableEls[0];
  var lastFocusableEl = focusableEls[focusableEls.length - 1];
  var KEYCODE_TAB = 9;

  element.addEventListener('keydown', function(e) {
    var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

    if (!isTabPressed) { 
      return; 
    }

    if ( e.shiftKey ) /* shift + tab */ {
      if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus();
          e.preventDefault();
        }
      } else /* tab */ {
      if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.focus();
          e.preventDefault();
        }
      }
  });
}